// extracted by mini-css-extract-plugin
module.exports = {"ComponentHolder":"CheckCredit_ComponentHolder__tGLIJ","buttonHolder":"CheckCredit_buttonHolder__3ll05"};